import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthService } from './shared/services/auth/auth.service';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./layout/components/login/login.module').then(lo => lo.LoginModule),
        resolve: [AuthService]
      },
    ]
  },
  // {
  //   path: '',
  //   canActivate: [AuthGuardService],
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule),
  //     },
  //   ]
  // },
  {
    path: '**',
    redirectTo: 'conference'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
